module.exports = "/8744259b4904c1e34b4784a38db71a08.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/images/brands/guinness.png
 ** module id = 2207
 ** module chunks = 0
 **/